import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

/**
 * Stacked bar chart showing study sessions per day by app type.
 */
export default function StudyActivityChart({ activity }) {
  const hasData = activity.some(d => d.total > 0);

  if (!hasData) {
    return (
      <div className="bg-gray-800/50 border border-gray-700/50 rounded-xl p-6">
        <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-4">Study Activity</h3>
        <div className="flex items-center justify-center h-48 text-gray-500 text-sm">
          Start studying to see your activity chart.
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-800/50 border border-gray-700/50 rounded-xl p-6">
      <h3 className="text-sm font-medium text-gray-400 uppercase tracking-wider mb-4">
        Study Activity (Last 30 Days)
      </h3>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={activity}>
          <CartesianGrid strokeDasharray="3 3" stroke="#374151" />
          <XAxis
            dataKey="shortDate"
            tick={{ fill: '#9CA3AF', fontSize: 9 }}
            interval={Math.floor(activity.length / 8)}
          />
          <YAxis allowDecimals={false} tick={{ fill: '#9CA3AF', fontSize: 11 }} />
          <Tooltip contentStyle={{ backgroundColor: '#1a1a2e', border: '1px solid #374151', borderRadius: 8 }} />
          <Legend wrapperStyle={{ color: '#9CA3AF', fontSize: 11 }} />
          <Bar dataKey="flashcard" name="Flashcards" stackId="a" fill="#4A90D9" radius={[0, 0, 0, 0]} />
          <Bar dataKey="drill" name="Drills" stackId="a" fill="#00ff41" />
          <Bar dataKey="exam" name="Exams" stackId="a" fill="#E74C3C" radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
